module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-with-heading",
    attrs: {
      "epub:type": "epigraph",
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "epigraph-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Introduction to Today I Remember")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("This story is a companion piece to “Today I Am Paul” (found later in this book). To see the connection, you’ll have to read my novel,")]), _vm._v(" Today I Am Carey"), _c('i', [_vm._v(", available from Baen Books.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("My father, A. John Shoemaker, was good at so many things I’m bad at: construction, welding, electrical work, auto mechanics, camping … I could go on. And my worlds of writing and programming were equally foreign to him. But one thing I got from him was his love of the circus, sheer amazement at people doing what no person should be able to do.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("And so, I was thrilled in my teens to discover the early works of Barry B. Longyear, whose first published stories told of a world settled by a circus troupe lost in the stars. Those stories made me a lifelong Longyear fan. He was the ")]), _vm._v("first"), _c('i', [_vm._v(" author whom I saw develop from the start of his career, and he made me believe that maybe someday I could be a writer, too. I still aspire to live up to his standard.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("So, this story is dedicated to the memory of my father, A. John Shoemaker, and to Barry B. Longyear. Life with the circus is one long uninterrupted deeeeelight!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6691261c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introductiontotodayiremember.vue
// module id = 75
// module chunks = 0